@if (lastLogin && lastLogin !== 'Invalid date') {
  <div class="last-login" data-cy="lastLogin">Last login: {{ lastLoginFormatted }}</div>
}
